import { Absent_getInstance1my5kmv368g0i as Absent_getInstance } from '../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Optional.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  toString1pkumu07cwy4m as toString,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
} from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var SavePartyInputClass;
function SavePartyInput() {
  if (SavePartyInputClass === VOID) {
    class $ {
      constructor(partyId, name, email, pairingRule, badgesEnabled, defaultBadgeName, alternateBadgeName, callSignsEnabled, animationsEnabled, animationSpeed) {
        name = name === VOID ? Absent_getInstance() : name;
        email = email === VOID ? Absent_getInstance() : email;
        pairingRule = pairingRule === VOID ? Absent_getInstance() : pairingRule;
        badgesEnabled = badgesEnabled === VOID ? Absent_getInstance() : badgesEnabled;
        defaultBadgeName = defaultBadgeName === VOID ? Absent_getInstance() : defaultBadgeName;
        alternateBadgeName = alternateBadgeName === VOID ? Absent_getInstance() : alternateBadgeName;
        callSignsEnabled = callSignsEnabled === VOID ? Absent_getInstance() : callSignsEnabled;
        animationsEnabled = animationsEnabled === VOID ? Absent_getInstance() : animationsEnabled;
        animationSpeed = animationSpeed === VOID ? Absent_getInstance() : animationSpeed;
        this.y6n_1 = partyId;
        this.z6n_1 = name;
        this.a6o_1 = email;
        this.b6o_1 = pairingRule;
        this.c6o_1 = badgesEnabled;
        this.d6o_1 = defaultBadgeName;
        this.e6o_1 = alternateBadgeName;
        this.f6o_1 = callSignsEnabled;
        this.g6o_1 = animationsEnabled;
        this.h6o_1 = animationSpeed;
      }
      toString() {
        return 'SavePartyInput(partyId=' + this.y6n_1.toString() + ', name=' + toString(this.z6n_1) + ', email=' + toString(this.a6o_1) + ', pairingRule=' + toString(this.b6o_1) + ', badgesEnabled=' + toString(this.c6o_1) + ', defaultBadgeName=' + toString(this.d6o_1) + ', alternateBadgeName=' + toString(this.e6o_1) + ', callSignsEnabled=' + toString(this.f6o_1) + ', animationsEnabled=' + toString(this.g6o_1) + ', animationSpeed=' + toString(this.h6o_1) + ')';
      }
      hashCode() {
        var result = this.y6n_1.hashCode();
        result = imul(result, 31) + hashCode(this.z6n_1) | 0;
        result = imul(result, 31) + hashCode(this.a6o_1) | 0;
        result = imul(result, 31) + hashCode(this.b6o_1) | 0;
        result = imul(result, 31) + hashCode(this.c6o_1) | 0;
        result = imul(result, 31) + hashCode(this.d6o_1) | 0;
        result = imul(result, 31) + hashCode(this.e6o_1) | 0;
        result = imul(result, 31) + hashCode(this.f6o_1) | 0;
        result = imul(result, 31) + hashCode(this.g6o_1) | 0;
        result = imul(result, 31) + hashCode(this.h6o_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof SavePartyInput()))
          return false;
        if (!this.y6n_1.equals(other.y6n_1))
          return false;
        if (!equals(this.z6n_1, other.z6n_1))
          return false;
        if (!equals(this.a6o_1, other.a6o_1))
          return false;
        if (!equals(this.b6o_1, other.b6o_1))
          return false;
        if (!equals(this.c6o_1, other.c6o_1))
          return false;
        if (!equals(this.d6o_1, other.d6o_1))
          return false;
        if (!equals(this.e6o_1, other.e6o_1))
          return false;
        if (!equals(this.f6o_1, other.f6o_1))
          return false;
        if (!equals(this.g6o_1, other.g6o_1))
          return false;
        if (!equals(this.h6o_1, other.h6o_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'SavePartyInput');
    SavePartyInputClass = $;
  }
  return SavePartyInputClass;
}
//region block: exports
export {
  SavePartyInput as SavePartyInput3ikp23en56cie,
};
//endregion

//# sourceMappingURL=SavePartyInput.mjs.map
